import { render, staticRenderFns } from "./student_roster.vue?vue&type=template&id=62b36ad9&scoped=true&"
import script from "./student_roster.vue?vue&type=script&lang=ts&"
export * from "./student_roster.vue?vue&type=script&lang=ts&"
import style0 from "./student_roster.vue?vue&type=style&index=0&id=62b36ad9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b36ad9",
  null
  
)

export default component.exports